import { getMessages } from '../../../../store/constants';

export const WEBINAR_FIRST_QUESTION = 'webinar';
export const WEBINAR_HIDE_TIMEOUT = 1000;

export const WEBINAR_QUESTIONS_TITLE = getMessages().getText('webinar.questions.title');
export const WEBINAR_QUESTIONS_SUBTITLE = getMessages().getText('webinar.questions.subTitle');
export const WEBINAR_GET_STARTED = getMessages().getText('webinar.getStarted');
export const WEBINAR_SKIP = getMessages().getText('webinar.skip');
